import { piscatawayConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function PiscatawayPage() {
  return <CityPageTemplate config={piscatawayConfig} />;
}